import { Action } from '@ngrx/store'
import * as NotDeliveredReasonTypes from './not-delivered-reason.types'
import { NotDeliveredReason } from './not-delivered-reason.interface'

export class FetchNotDeliveredReasonListRequest implements Action {
  readonly type =
    NotDeliveredReasonTypes.FETCH_NOT_DELIVERED_REASON_LIST_REQUEST
  constructor(public payload: any = {}) {}
}

export class FetchNotDeliveredReasonListSuccess implements Action {
  readonly type =
    NotDeliveredReasonTypes.FETCH_NOT_DELIVERED_REASON_LIST_SUCCESS
  constructor(
    public payload: NotDeliveredReason[],
    public total: number,
    public results: number,
  ) {}
}

export class FetchNotDeliveredReasonListFailure implements Action {
  readonly type =
    NotDeliveredReasonTypes.FETCH_NOT_DELIVERED_REASON_LIST_FAILURE
  constructor(public payload: any) {}
}

export class FetchNotDeliveredReasonRequest implements Action {
  readonly type = NotDeliveredReasonTypes.FETCH_NOT_DELIVERED_REASON_REQUEST
  constructor(public id: number) {}
}

export class FetchNotDeliveredReasonSuccess implements Action {
  readonly type = NotDeliveredReasonTypes.FETCH_NOT_DELIVERED_REASON_SUCCESS
  constructor(public payload: NotDeliveredReason) {}
}

export class FetchNotDeliveredReasonFailure implements Action {
  readonly type = NotDeliveredReasonTypes.FETCH_NOT_DELIVERED_REASON_FAILURE
  constructor(public payload: any) {}
}

export class DeleteNotDeliveredReasonRequest implements Action {
  readonly type = NotDeliveredReasonTypes.DELETE_NOT_DELIVERED_REASON_REQUEST
  constructor(public id: number) {}
}

export class DeleteNotDeliveredReasonSuccess implements Action {
  readonly type = NotDeliveredReasonTypes.DELETE_NOT_DELIVERED_REASON_SUCCESS
  constructor() {}
}

export class DeleteNotDeliveredReasonFailure implements Action {
  readonly type = NotDeliveredReasonTypes.DELETE_NOT_DELIVERED_REASON_FAILURE
  constructor(public payload: any) {}
}

export class CreateNotDeliveredReasonRequest implements Action {
  readonly type = NotDeliveredReasonTypes.CREATE_NOT_DELIVERED_REASON_REQUEST
  constructor(public payload) {}
}

export class CreateNotDeliveredReasonSuccess implements Action {
  readonly type = NotDeliveredReasonTypes.CREATE_NOT_DELIVERED_REASON_SUCCESS
  constructor() {}
}

export class CreateNotDeliveredReasonFailure implements Action {
  readonly type = NotDeliveredReasonTypes.CREATE_NOT_DELIVERED_REASON_FAILURE
  constructor(public payload: any) {}
}

export class UpdateNotDeliveredReasonRequest implements Action {
  readonly type = NotDeliveredReasonTypes.UPDATE_NOT_DELIVERED_REASON_REQUEST
  constructor(public id: number, public payload) {}
}

export class UpdateNotDeliveredReasonSuccess implements Action {
  readonly type = NotDeliveredReasonTypes.UPDATE_NOT_DELIVERED_REASON_SUCCESS
  constructor() {}
}

export class UpdateNotDeliveredReasonFailure implements Action {
  readonly type = NotDeliveredReasonTypes.UPDATE_NOT_DELIVERED_REASON_FAILURE
  constructor(public payload: any) {}
}

export class UpdateField implements Action {
  readonly type = NotDeliveredReasonTypes.UPDATE_FIELD
  public constructor(
    public field: string,
    public value: any,
    public path: string,
  ) {}
}

export class SetDefaultData implements Action {
  readonly type = NotDeliveredReasonTypes.SET_DEFAULT_DATA
  public constructor(public path: string) {}
}

export type Actions =
  | UpdateNotDeliveredReasonRequest
  | UpdateNotDeliveredReasonSuccess
  | UpdateNotDeliveredReasonFailure
  | FetchNotDeliveredReasonListSuccess
  | FetchNotDeliveredReasonListFailure
  | FetchNotDeliveredReasonListRequest
  | FetchNotDeliveredReasonSuccess
  | FetchNotDeliveredReasonFailure
  | FetchNotDeliveredReasonRequest
  | CreateNotDeliveredReasonRequest
  | CreateNotDeliveredReasonSuccess
  | CreateNotDeliveredReasonFailure
  | DeleteNotDeliveredReasonRequest
  | DeleteNotDeliveredReasonSuccess
  | DeleteNotDeliveredReasonFailure
  | SetDefaultData
  | UpdateField
  | FetchNotDeliveredReasonRequest
  | FetchNotDeliveredReasonSuccess
  | FetchNotDeliveredReasonFailure
